import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';

import { LadderNotification, MaxRewardNotification } from '../../../model';

@Component({
    selector: 'bs-acca-boost-ladder-us-info-legs-list',
    templateUrl: './acca-boost-ladder-us-info-legs-list.component.html',
    styleUrls: ['./acca-boost-ladder-us-info-legs-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class AccaBoostLadderUsInfoLegsListComponent {
    @Input() pickCount: number;
    @Input() notification: LadderNotification | MaxRewardNotification;

    constructor(public sitecore: Sitecore) {}
}
